var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapDao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.296 1.90764L1.79604 17.3622C1.29476 17.7401 1 18.3314 1 18.9592V44C1 45.1046 1.89543 46 3 46H12.95C14.0546 46 14.95 45.1046 14.95 44V36.75C14.95 35.6454 15.8454 34.75 16.95 34.75H29.6C30.7046 34.75 31.6 35.6454 31.6 36.75V44C31.6 45.1046 32.4954 46 33.6 46H44C45.1046 46 46 45.1046 46 44V18.9592C46 18.3314 45.7052 17.7401 45.204 17.3622L24.704 1.90764C23.9912 1.37034 23.0088 1.37034 22.296 1.90764Z",
    fill: "url(#paint0_linear_1181_22065)",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_22065",
    x1: 1,
    y1: 1,
    x2: 47.9424,
    y2: 3.12676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapDao);
export default __webpack_public_path__ + "static/media/roadmap_dao.eda09d2b01a8ec181fef3657090f1083.svg";
export { ForwardRef as ReactComponent };